var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3335,
    cy: 15.1992,
    r: 14.5,
    fill: "#F4F6FE",
    stroke: "#1737E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3324 11.5078H11.6368C11.0389 11.5078 10.5552 11.9969 10.5552 12.5948L10.5498 19.1165C10.5498 19.7143 11.0389 20.2035 11.6368 20.2035H20.3324C20.9302 20.2035 21.4194 19.7143 21.4194 19.1165V12.5948C21.4194 11.9969 20.9302 11.5078 20.3324 11.5078ZM20.115 13.8176L16.2726 16.2198C16.0987 16.3285 15.8705 16.3285 15.6965 16.2198L11.8542 13.8176C11.7183 13.7306 11.6368 13.5839 11.6368 13.4263C11.6368 13.0622 12.0335 12.8448 12.3433 13.035L15.9846 15.3122L19.6259 13.035C19.9357 12.8448 20.3324 13.0622 20.3324 13.4263C20.3324 13.5839 20.2509 13.7306 20.115 13.8176Z",
    fill: "#1737E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGroup);
export default __webpack_public_path__ + "static/media/emailGroup.a85b0811a59211a76613d0637c016245.svg";
export { ForwardRef as ReactComponent };